import { render } from "./Feest.vue?vue&type=template&id=aab4ce72&scoped=true"
import script from "./Feest.vue?vue&type=script&lang=js"
export * from "./Feest.vue?vue&type=script&lang=js"

import "./Feest.vue?vue&type=style&index=0&id=aab4ce72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab4ce72"]])

export default __exports__